import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpeechCloud = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 28L6.53333 20.4C5.32951 17.9931 5.02149 15.2363 5.66441 12.623C6.30732 10.0097 7.85921 7.71043 10.0423 6.13672C12.2255 4.56302 14.8974 3.81754 17.5799 4.03371C20.2624 4.24987 22.7805 5.41356 24.6835 7.31654C26.5864 9.21952 27.7501 11.7376 27.9663 14.4201C28.1825 17.1026 27.437 19.7745 25.8633 21.9577C24.2896 24.1408 21.9903 25.6927 19.3771 26.3356C16.7638 26.9785 14.007 26.6705 11.6 25.4667L4 28Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgSpeechCloud);
export default ForwardRef;
